// ##### 23-06-22 Komarov
import React from 'react';

import coffeeGif from './caffeine-rush-coffee-1.gif';
// ##### 23-09-14 Komarov
// import "./CupOfCoffee.css";

// ##### Komarov 2025-07-14
const CupOfCoffee = ({ empty = false }) => {
  return (
    (empty && <></>) || (
      <div className="pre-loader" data-component="CupOfCoffee">
        {/* <h1>Animated GIF Example</h1> */}
        <img src={coffeeGif} alt="Animated GIF" />
      </div>
    )
  );
};

// ##### 25-05-21 Komarov
export default CupOfCoffee;
